module.exports = __webpack_public_path__ + "static/pricing-icon-button-e44a375146df2b23acf8be39a4a35b8c.png";